import {
  Box,
  Button,
  CircularProgress,
  Pagination,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { UserReturnAcknowledgementStore } from "../../../../../store/main/UserReturnAcknowledgementStore";
import ReportFiltersComponent from "../../ReportFiltersComponent";
import ReportScreen from "../../../../../common/enums/ReportScreens";
import { CustomerDatabaseStore } from "../../../../../store/main/CustomerDatabaseStore";
import moment from "moment";
import { ReportFilters } from "../../../../../domain/models/report-filters";
import { useEffect, useState } from "react";
import ReportFiltersLoading from "../../ReportFiltersLoading";
import AddReturnAcknowledgementModal from "../Modal/AddReturnAcknowledgementModal";
import { AllInputPosType, PaginatedType } from "../../../../../domain/models/user-return-acknowledgement/user-return-pos";
import { sampleAcknowledgementScope } from "../../../../../common/constants/constant";

const commonReturnTableStyle = {
  border: "1px solid #e0e0e0",
  py: 0.5,
};

type ReturnParams = {
  month: string;
  year: number;
  scope: string;
  page: number;
};

const ManagerReturnPos = () => {
  const {
    fetchUserReturnPos,
    
  } = UserReturnAcknowledgementStore();

  const { userDetails, decodeToken, userRole } = CustomerDatabaseStore();

  const currentDate = new Date();
  const defaultMonth = currentDate.getMonth() + 1;
  const defaultYear = currentDate.getFullYear();
  const [month, setMonth] = useState<number>(defaultMonth);
  const [year, setYear] = useState<number>(defaultYear);
  const [loading, setLoading] = useState<boolean>(false);
  const [openReturnModal, setOpenReturnModal] = useState<boolean>(false);
  const [returnPosData, setReturnPosData] = useState<AllInputPosType[]>([]);
  const [selectedInputReturnRow, setSelectedInputReturnRow] =
    useState<AllInputPosType | null>(null);
     const [pagination, setPagination] = useState<PaginatedType | null>(null);

  useEffect(() => {
    decodeToken();
  }, []);

  useEffect(() => {
    fetchAndSetReturnData(month, year,  setLoading, setReturnPosData);
  }, [month, year]);

  const fetchAndSetReturnData = async (
    month: number,
    year: number,
    setLoading: (loading: boolean) => void,
    setReturnPosData: (data: any) => void,
    page: number = 1,
  ) => {
    setLoading(true);
    const monthString = month.toString().padStart(2, "0");

    const returnParams: ReturnParams = {
      month: monthString,
      year,
      scope: sampleAcknowledgementScope.CHILDREN,
      page
    };

    try {
      const response = await fetchUserReturnPos(returnParams);
      if (response.success) {
        setReturnPosData(response.input_pos);
        setPagination(response.paginated);
      }
       if (response.paginated) {
    }
    } catch (error) {
      console.error("Failed to fetch data", error);
    } finally {
      setLoading(false);
    }
  };

  const filterData = async (filter: ReportFilters) => {
    const month = parseInt(moment(filter.date?.toString()).format("MM"));
    const year = parseInt(moment(filter.date?.toString()).format("YYYY"));
    setMonth(month);
    setYear(year);

    await fetchAndSetReturnData(month, year, setLoading, setReturnPosData);
  };

   const clearData = async () => {
    setMonth(defaultMonth);
    setYear(defaultYear);
    await fetchAndSetReturnData(
      defaultMonth,
      defaultYear,
      setLoading,
      setReturnPosData
    );
  };

  const refreshData = async () => {
    await fetchAndSetReturnData(month, year, setLoading, setReturnPosData);
  };

  const handleOpenModal = (row: AllInputPosType) => {
    setSelectedInputReturnRow(row);
    setOpenReturnModal(true);
  };

  const handleCloseModal = () => {
    setOpenReturnModal(false);
    setSelectedInputReturnRow(null);
  };

    const handlePageChange = async (_: React.ChangeEvent<unknown>, value: number) => {
  await fetchAndSetReturnData(month, year, setLoading, setReturnPosData, value);
};

  return (
    <>
      <Box pl={2} pt={1}>
        <Box mt={2}>
          {Object.keys(userDetails).length > 0 ? (
            <ReportFiltersComponent
              type={ReportScreen.USER_RETURN_ACKNOWLEDGEMENT}
              successCallback={filterData}
              clearSuccessCallBack={clearData}
              userRole={userRole.role}
              userDetails={userDetails}
              gridColumns={24}
              territoryMultiSelect={false}
            />
          ) : (
            <ReportFiltersLoading />
          )}
        </Box>
      </Box>

      {loading ? (
        <Box display="flex" justifyContent="center" mt={4}>
          <CircularProgress />
        </Box>
      ) : returnPosData.length === 0 ? (
        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          height="80vh"
          textAlign="center"
        >
          <Typography variant="h3" color="text.secondary">
            Acknowledge Data is not available for this month.
          </Typography>
        </Box>
      ) : (
        <TableContainer
          component={Paper}
          sx={{
            mt: 3,
            ml: "auto",
            mr: "auto",
            maxHeight: 500,
            overflowY: "auto",
            width: "95%",
          }}
        >
          <Table stickyHeader aria-label="input-pos-table">
            <TableHead>
              <TableRow>
                {[
                  "User Name",
                  "Product Name",
                  "Month of Use",
                  "Batch No",
                  "Product Type",
                  "Quantity Dispatched",
                  "Quantity Acknowledged",
                  "Quantity Reported",
                  "Quantity Returned",
                  "Actions",
                ].map((header) => (
                  <TableCell
                    key={header}
                    align="center"
                    sx={{
                      fontWeight: "bold",
                      border: "1px solid #ccc",
                      backgroundColor: "#0D71B7",
                      color: "#ffffff",
                      position: "sticky",
                      top: 0,
                      zIndex: 1,
                      py: 1,
                    }}
                  >
                    {header}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
                {returnPosData.map((pos) => (  
                  <TableRow key={pos.id}>
                     <TableCell align="center" sx={commonReturnTableStyle}>
                      {pos.user_name ? `${pos.user_name}` : "—"}
                    </TableCell>
                    <TableCell align="center" sx={commonReturnTableStyle}>
                      {pos.product_name}
                    </TableCell>
                    <TableCell align="center" sx={commonReturnTableStyle}>
                      {pos.month_of_use}
                    </TableCell>
                    <TableCell align="center" sx={commonReturnTableStyle}>
                      {pos.batch_no || "—"}
                    </TableCell>
                    <TableCell align="center" sx={commonReturnTableStyle}>
                      {pos.product_type}
                    </TableCell>
                    <TableCell align="center" sx={commonReturnTableStyle}>
                      {pos.quantity_dispatched}
                    </TableCell>
                    <TableCell align="center" sx={commonReturnTableStyle}>
                      {pos.quantity_acknowledged}
                    </TableCell>
                    <TableCell align="center" sx={commonReturnTableStyle}>
                      {pos.quantity_used}
                    </TableCell>
                    <TableCell align="center" sx={commonReturnTableStyle}>
                      {pos.quantity_returned}
                    </TableCell>
                    <TableCell align="center" sx={commonReturnTableStyle}>
                      {pos.quantity_acknowledged && (
                        <Button
                          variant="outlined"
                          size="small"
                          onClick={() => handleOpenModal(pos)}
                        >
                          Return
                        </Button>
                      )}

                      {openReturnModal && selectedInputReturnRow && (
                        <AddReturnAcknowledgementModal<AllInputPosType>
                          open={openReturnModal}
                          onClose={handleCloseModal}
                          data={selectedInputReturnRow}
                          onSuccess={refreshData}
                        />
                      )}
                    </TableCell>
                  </TableRow>
              )
              )}
            </TableBody>
          </Table>
        </TableContainer>
      )}
         {pagination && (
        <Box display="flex" justifyContent="center" mt={2} mb={2}>
          <Pagination
            count={Math.ceil(pagination.total / pagination.per_page)}
            page={pagination.current_page} 
            variant="outlined"
            color="primary"
            onChange={handlePageChange}
          />
        </Box>
      )}
    </>
  );
};

export default ManagerReturnPos;
